import React, { ReactNode, CSSProperties } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

interface Props {
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
  size?: 'md' | 'lg' | 'sm';
}

function WingBlack(props: Props) {
  const { className, style, children, size = 'md' } = props;
  const cls = cn(styles.container, styles[`container-${size}`], className);

  return (
    <div className={cls} style={style}>
      {children}
    </div>
  );
}

export default WingBlack;
